import React from 'react'

import { Dialog, useDialogState } from '../../../../main/components/dialog'
import { Spinner } from '../../../../main/components/spinner'
import { useAsyncModule } from '../../../../main/services/async-modules-utils'
import { QuoteContext } from '../../QuoteContext'
import { saveToPortfolioAsyncModule } from '../../save-to-portfolio/async-modules'
import { NavigationLink } from './QuoteLinkComponent'

export function SaveToPortfolioLink() {
  const { ticker } = React.useContext(QuoteContext)
  const dialog = useDialogState()
  const isVisible = dialog.useState('open')

  const [saveToPortfolioModule] = useAsyncModule({
    ...saveToPortfolioAsyncModule,
    shouldLoadModule: isVisible,
  })
  const SaveToPortfolio = saveToPortfolioModule?.SaveToPortfolio

  return (
    <>
      <NavigationLink
        getLink={() => `/save_to_portfolio.ashx?t=${ticker}`}
        onClick={(e) => {
          window.gtag?.('event', 'click', { event_category: 'save-to-portfolio' })
          if (e.ctrlKey || e.metaKey) return
          e.preventDefault() // needed to prevent opening parent link
          dialog.show()
        }}
      >
        Add to Portfolio
      </NavigationLink>
      <Dialog state={dialog} aria-label="Add to Portfolio" className="w-110">
        {SaveToPortfolio ? (
          <SaveToPortfolio ticker={ticker} />
        ) : (
          <div className="flex h-56 items-center justify-center">
            <Spinner />
          </div>
        )}
      </Dialog>
    </>
  )
}
